<p-toast [baseZIndex]="10000"></p-toast>

<p-accordion multiple="true" [value]="filterToShow" [hidden]="isLoading">
  <p-accordion-panel [value]="chartsFilter" id="accordion">
    <p-accordion-header>
      <span class="pi pi-search mr-4"> </span>
      <div class="mr-auto">
        {{ 'Search' | translate }}
        (
          {{ filtersSelected.fromDate | date:'yyyy-MM-dd' }} - {{ this.dateRange[1] | date: 'yyyy-MM-dd' }} {{ filtersSelected.fromDate ? '| ' : '' }}
          {{ formattedCountriesSelected }}        {{ formattedCountriesSelected ? '|' : '' }}
          {{ formattedAirlinesSelected }}         {{ formattedAirlinesSelected ? '|' : '' }}
          {{ formattedDocumentTypesSelected }}    {{ formattedDocumentTypesSelected ? '|' : '' }}
          {{ formattedAgentsSelected }}           {{ formattedAgentsSelected ? '|' : '' }}
          {{ formattedAgentsGroupsSelected }}     {{ formattedAgentsGroupsSelected ? '|' : '' }}
          {{ formattedContractsSelected }}        {{ formattedContractsSelected ? '|' : '' }}
          {{ filtersSelected.currency.code }}
        )
      </div>
    </p-accordion-header>

    <p-accordion-content>
        <form class="my-3 mx-3 d-flex row">
          <div class="offset-1 col-9 mr-5">
            <div class="row">
              <div class="row form-inline col-12 mb-2">
                <div class="col mb-2 col-3">
                  <p-floatlabel>
                    <p-datePicker inputId="dates"
                                  name="dates"
                                  dateFormat="yy-mm-dd"
                                  appendTo="body"
                                  selectionMode="range"
                                  [readonlyInput]="true"
                                  [showIcon]="true"
                                  [(ngModel)]="dateRange"
                                  [disabled]="isLoadingComboData"
                                  [firstDayOfWeek]="firstDayWeek"
                                  (onSelect)="buildDate(dateRange, true)"
                                  [minDate]="minDate"
                                  [maxDate]="maxDate"
                                  (onClickOutside)="setDateTo()"
                                  required />
                    <label class="required" for="dateFrom" translate> Common.From Date </label>
                  </p-floatlabel>
                  <small *ngIf="!validDateRange" class="text-danger" translate> {{ 'Maximum Months' | translate: { maxMonthsAllowed: maxMonthsAllowed } }}  </small>
                </div>

                <div class="col mb-2 col-3">
                  <p-floatlabel>
                    <p-multiSelect
                      id="countriesSelected"
                      name="countriesSelected"
                      #countriesSelected="ngModel"
                      appendTo="body"
                      optionLabel="code"
                      [options]="countries"
                      [(ngModel)]="filtersSelected.countries"
                      [disabled]="isLoadingComboData || !this.filtersSelected.fromDate"
                      [maxSelectedLabels]="10"
                      (onChange)="buildDataCombo(filtersSelected.countries, countriesSelectedStr); formatFilter('countries', 'formattedCountriesSelected', 'code', 21)"
                    >
                    </p-multiSelect>
                    <label for="countriesSelected" translate> Common.Countries </label>
                  </p-floatlabel>
                </div>

                <div class="col mb-2 col-3">
                  <p-floatlabel>
                    <p-multiSelect
                      id="airlinesSelected"
                      name="airlinesSelected"
                      #airlinesSelected="ngModel"
                      appendTo="body"
                      optionLabel="code"
                      [options]="airlines"
                      [(ngModel)]="filtersSelected.airlines"
                      [disabled]="isLoadingComboData || !this.filtersSelected.fromDate"
                      [maxSelectedLabels]="7"
                      (onChange)="buildDataCombo(filtersSelected.airlines, airlinesSelectedStr); formatFilter('airlines', 'formattedAirlinesSelected', 'code', 12)"
                    >
                    </p-multiSelect>
                    <label for="airlinesSelected" translate> Common.Airlines </label>
                  </p-floatlabel>
                </div>

                <div class="col mb-2 col-3">
                  <p-floatlabel>
                    <p-multiSelect
                      id="documentsSelected"
                      name="documentsSelected"
                      #documentsSelected="ngModel"
                      appendTo="body"
                      optionLabel="code"
                      [options]="documentTypes"
                      [(ngModel)]="filtersSelected.documentTypes"
                      [disabled]="isLoadingComboData || !this.filtersSelected.fromDate"
                      [maxSelectedLabels]="5"
                      [showToggleAll]="false"
                      (onChange)="formatFilter('documentTypes', 'formattedDocumentTypesSelected', 'code', 24); checkDocumentsSelected()"
                      required
                    >
                    </p-multiSelect>
                    <label for="documentsSelected" translate> Common.Document Type </label>
                  </p-floatlabel>
                </div>
              </div>

              <div class="row form-inline col-12 mb-2">
                <div class="col mb-2 col-3">
                  <p-floatlabel>
                    <p-multiSelect
                      name="agentsSelected"
                      #agentsSelected="ngModel"
                      id="agentsSelected"
                      appendTo="body"
                      optionLabel="code"
                      [loading]="isLoadingComboData"
                      [options]="agents"
                      [(ngModel)]="filtersSelected.agents"
                      [disabled]="isLoadingComboData || (!this.filtersSelected.fromDate || filtersSelected.countries.length == 0)"
                      (onChange)="formatFilter('agents', 'formattedAgentsSelected', 'id', 28)"
                      required
                    >
                    </p-multiSelect>
                    <label for="documentsSelected" translate> Agents </label>
                  </p-floatlabel>
                </div>
                <div class="col mb-2 col-3">
                  <p-floatlabel>
                    <p-multiSelect
                      name="agentsGroupsSelected"
                      #agentsGroupsSelected="ngModel"
                      id="agentsGroupsSelected"
                      appendTo="body"
                      optionLabel="code"
                      [loading]="isLoadingComboData"
                      [options]="agentsGroups"
                      [(ngModel)]="filtersSelected.agentsGroups"
                      [disabled]="isLoadingComboData || (!this.filtersSelected.fromDate || filtersSelected.countries.length == 0)"
                      (onChange)="formatFilter('agentsGroups', 'formattedAgentsGroupsSelected', 'id', 33)"
                      required
                    >
                    </p-multiSelect>
                    <label for="documentsSelected" translate> Agents Groups </label>
                  </p-floatlabel>
                </div>
                <div class="col mb-2 col-3">
                  <p-floatlabel>
                    <p-multiSelect
                      name="contractsSelected"
                      #contractsSelected="ngModel"
                      id="contractsSelected"
                      appendTo="body"
                      [loading]="isLoadingComboData"
                      [options]="contracts"
                      optionLabel="code"
                      [(ngModel)]="filtersSelected.contracts"
                      [disabled]="isLoadingComboData || (!this.filtersSelected.fromDate || filtersSelected.countries.length == 0)"
                      (onChange)="formatFilter('contracts', 'formattedContractsSelected', 'id', 33)"
                      required
                    >
                    </p-multiSelect>
                    <label for="documentsSelected" translate> Contracts </label>
                  </p-floatlabel>
                </div>
                <div class="col">
                    @if(!isNotConvertible){
                      <p-floatlabel>
                          <p-select
                            #countryCode="ngModel"
                            name="countryCode"
                            appendTo="body"
                            optionLabel="code"
                            optionValue="code"
                            [options]="currencies"
                            *ngIf="filtersSelected?.currency as currency"
                            [(ngModel)]="currency.code"
                            (onChange)="formatConversion($event, 'currency')"
                          />
                          <label translate> Conversion </label>
                      </p-floatlabel>
                    }
                </div>
              </div>
            </div>
          </div>
          <div class="col-1">
            <div class="container mt-3">
              <div class="row text-right">
                  <p-button severity="primary" icon="pi pi-check" type="submit" (click)="applyFilter()" label="{{ 'Apply' | translate }}" class="my-3"
                          [disabled]="checkApplyFilters()">
                  </p-button>
                  <p-button severity="contrast" icon="pi pi-eraser" label="{{ 'Common.Clear' | translate }}" [disabled]="isLoadingComboData || isLoading" (click)="clearSelection()"> </p-button>
              </div>
            </div>
          </div>
        </form>
    </p-accordion-content>
  </p-accordion-panel>
</p-accordion>
